import { t } from "@travily/i18n";
import { ButtonGroup, ButtonGroupItem } from "@ui/components/ButtonGroup";
import { firstSelectedKey } from "@ui/lib/selection";
import type { Selection } from "@ui/primitives/shared";
import { AVAILABILITY_OPTIONS, type ProgramAvailabilityFilterValue } from "../constants";

export interface ProgramsAvailabilityFilterProps {
  onChange: (value: ProgramAvailabilityFilterValue) => void;
  value: ProgramAvailabilityFilterValue;
}

export function ProgramsAvailabilityFilter({ onChange, value }: ProgramsAvailabilityFilterProps) {
  const handleSelectionChange = (keys: Selection) => {
    const selected = firstSelectedKey(keys);
    if (selected) onChange(selected as ProgramAvailabilityFilterValue);
  };

  return (
    <ButtonGroup
      aria-label={t("components.views.programs.search.availability_label")}
      disallowEmptySelection
      onSelectionChange={handleSelectionChange}
      selectedKeys={new Set([value])}
      selectionMode="single"
      size="lg"
    >
      {AVAILABILITY_OPTIONS.map((option) => (
        <ButtonGroupItem id={option.value} key={option.value}>
          {t(option.labelKey)}
        </ButtonGroupItem>
      ))}
    </ButtonGroup>
  );
}
